function initBlogSplitSwiper(el) {
  if (el.swiper) return;

  const slideCount = el.querySelectorAll('.swiper-slide').length;

  new Swiper(el, {
    slidesPerView: 1.125,
    centeredSlides: true,
    initialSlide: 1,  
    spaceBetween: 16,
    loop: slideCount > 1,                    // no point looping 1 slide
    loopAdditionalSlides: slideCount <= 3 ? 3 : 0,  // extra clones only when few slides
    pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
  });

  el.addEventListener('click', (e) => {
    if (e.target.closest('.swiper-pagination')) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    if (x < rect.width / 2) el.swiper.slidePrev();
    else el.swiper.slideNext();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-blog-split-swiper]').forEach(initBlogSplitSwiper);
});

document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll('[data-blog-split-swiper]').forEach(initBlogSplitSwiper);
});